export const MAILCHIMP_SNIPPET = 'https://wakefieldproductions.us7.list-manage.com/subscribe/post?u=aa566ecee5f06387e4184b7e8&id=2f16f4c279'
